import { ProviderBusinessInfo } from "../../../../model/provider/provider-dashboard-data";
import { formatNumber } from "../../../../utils";
import styles from "./SolarProviderCards.module.scss";

export interface SolarProviderCardProps {
	data?: ProviderBusinessInfo;
}

const SolarProviderCards: React.FC<SolarProviderCardProps> = ({ data }) => {
	const formatRevenue = (revenue?: number) => {
		if(revenue === undefined) return "-";

		return `₦ ${revenue.toLocaleString()}`;
	}

	return (
		<div className={styles.cardsContainer}>
			<div className={`${styles.card} ${styles.purpleCard}`}>
				<div className={styles.cardHeader}>Order Completed</div>
				<div className={styles.cardBody}>{data?.ordersCompleted.toLocaleString() ?? "-"}</div>
			</div>
			<div className={`${styles.card} ${styles.orangeCard}`}>
				<div className={styles.cardHeader}>Order In progress</div>
				<div className={styles.cardBody}>{data?.ordersInProgress.toLocaleString() ?? "-"}</div>
			</div>
			<div className={`${styles.card} ${styles.greenCard}`}>
				<div className={styles.cardHeader}>Number of Solar Products</div>
				<div className={styles.cardBody}>{data?.numberOfSolarProducts.toLocaleString() ?? "-"}</div>
			</div>
			<div className={`${styles.card} ${styles.greenCard}`}>
				<div className={styles.cardHeader}>Revenue</div>
				<div className={styles.cardBody}>{formatRevenue(data?.revenue)}</div>
			</div>
		</div>
	);
};

export default SolarProviderCards;
